// extracted by mini-css-extract-plugin
module.exports = {"controls":"bsc_p","monthControls":"VYB2K","monthButton":"_2ULQK","back":"_2WtGM","month":"_29qRC","loading":"A4MGC","next":"Kr0bT","days":"_3t237"};